module.exports = __webpack_public_path__ + "static/media/Dana.a86eecce.png";